import { SAVE_IMPORT_FILE } from "@/store/mutation-types";
import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
export default {
  actions: {
    importFile: ({ dispatch }, payload) => {
        return ApiRequest.explorePost("json_file", payload, GetHeaders.dataHeaders()).then(
          res => {
            dispatch("saveImportFile", res.data)
            return res.data
          }
        );
    },
    saveImportFile: ({ commit }, payload) => {
      return new Promise((resolve) => {
        commit("SAVE_IMPORT_FILE", payload);
        resolve();
      })
    }
  },
  getters: {
  },
  mutations: {
    [SAVE_IMPORT_FILE](state, payload) {
      state.importedFile = payload;
    }
  },
  state: {
    importedFile: null
  }
};
